import { CustomerAPI } from 'api'
import { from } from 'rxjs'
import { checkStatus } from 'utils/rxUtils'

export const api = {
   patchUserProperties(userId, properties) {
     return from(CustomerAPI
       .patch(`/users/${userId}/properties`, properties))
       .pipe(
         checkStatus()
       )
   }
}